import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { FC, Fragment, ReactNode } from 'react';

interface IModalProps {
  open: boolean;
  onClose: () => void;
  className?: string;
  children: ReactNode;
}

const Modal: FC<IModalProps> = ({ open, onClose, className, children }) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <div className="fixed inset-0 bg-[#1F2B40BF]/75 backdrop-blur-sm" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95">
            <DialogPanel
              className={`relative w-full max-w-md rounded-2xl text-white shadow-xl ${className}`}>
              <button
                onClick={onClose}
                className="absolute cursor-pointer top-4 right-4 text-white hover:text-gray-300 transition">
                <XCircleIcon className="h-6 w-6" />
              </button>
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
